import { render } from "./GeneralTermsAndConditions.vue?vue&type=template&id=20e7b1ba&scoped=true"
import script from "./GeneralTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./GeneralTermsAndConditions.vue?vue&type=script&lang=js"

import "./GeneralTermsAndConditions.vue?vue&type=style&index=0&id=20e7b1ba&scoped=true&lang=scss"

import exportComponent from "/Users/kovacsistvan/develop/segito-kezek/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e7b1ba"]])

export default __exports__